import React from "react";

export default function Results() {
  return (
    <div className="max-width">
      <div>
        <p className="center title-block1">RUG Past Results</p>
      </div>
      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold center">BAPC 2021</p>
          <ul className="size24 ">
            <li className="list1">#43. RUG5</li>
            <li className="list1">#47. RUG1</li>
            <li className="list1">#56. RUG3</li>
            <li className="list1">#59. RUG4</li>
            <li className="list1">#60. RUG2</li>
          </ul>
        </div>
        <div className="table">
          <p className="text-block1 bold center">NWERC 2021</p>
          <ul className="size24 ">
            <li className="list1">#82. N-RUG2</li>
            <li className="list1">#125. N-RUG1</li>
          </ul>
        </div>
      </div>
      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold center">BAPC 2022</p>
          <ul className="size24 ">
            <li className="list1 bold bronze-text">
              #12. Balloon Addicts, Passionate Coders (bronze medal)
            </li>
            <li className="list1">#22. Rodina</li>
            <li className="list1">#27. The Pool Party</li>
            <li className="list1">#39. 3Guys1Segfault</li>
            <li className="list1">#40. while (true) height--;</li>
          </ul>
        </div>
        <div className="table">
          <p className="text-block1 bold center">NWERC 2022</p>
          <ul className="size24 ">
            <li className="list1">#86. The Pool Party</li>
            <li className="list1">#88. Balloon Addicts, Passionate Coders</li>
            <li className="list1">#99. Rodina</li>
            <li className="list1">#106. 3Guys1Segfault</li>
          </ul>
        </div>
      </div>

      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold center">BAPC 2023</p>
          <ul className="size24 ">
            <li className="list1">#25. LLaMA Prophets</li>
            <li className="list1">#28. Rodina</li>
            <li className="list1">#30. Balloon Addicts Passionate Coders</li>
            <li className="list1">#31. The Pool Party</li>
            <li className="list1">#38. National team of Switzerland</li>
          </ul>
        </div>
        <div className="table">
          <p className="text-block1 bold center">NWERC 2023</p>
          <ul className="size24 ">
            <li className="list1">#58. Rodina</li>
            <li className="list1">#80. LLaMA Prophets</li>
            <li className="list1">#97. Balloon Addicts Passionate Coders</li>
          </ul>
        </div>
      </div>

      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold center">BAPC 2024</p>
          <ul className="size24 ">
            <li className="list1 bold bronze-text">
              #11. A random triennial (bronze medal)
            </li>
            <li className="list1">#18. Central Processing Unit</li>
            <li className="list1">#29. Hopefully Not Last</li>
            <li className="list1">#41. National Team of Yugoslavia</li>
            <li className="list1">#46. ByteBlitz</li>
          </ul>
        </div>
        <div className="table">
          <p className="text-block1 bold center">NWERC 2024</p>
          <ul className="size24 ">
            <li className="list1">#45. A random triennial</li>
          </ul>
        </div>
      </div>

      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold center">BAPC 2025</p>
          <ul className="size24 ">
            <li className="list1 bold bronze-text">
              #11. Triply Linked List (bronze medal)
            </li>
            <li className="list1">#22. BrainLimitExceeded</li>
            <li className="list1">#31. man idk don't put a name</li>
            <li className="list1">#40. 3Guys1Segfault</li>
          </ul>
        </div>
        <div className="table">
          <p className="text-block1 bold center">NWERC 2025</p>
          <ul className="size24 ">
            <li className="list1">#67. Triply Linked List</li>
            <li className="list1">#101. BrainLimitExceeded</li>
          </ul>
        </div>
      </div>

      <div className="center1 table-container">
        <div className="table">
          <p className="text-block1 bold gold-text center">NKP/BAPC Winners</p>
          <ul className="size24">
            <li className="list1">
              1992. TBD (shared with University of Amsterdam)
            </li>
            <li className="list1">
              1993. TBD (shared with University of Amsterdam)
            </li>
            <li className="list1">1995. m38c</li>
            <li className="list1">1997. *scratch*</li>
            <li className="list1">2000. Bug Fiction</li>
            <li className="list1">2002. Bug Fiction</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
